import { render, staticRenderFns } from "./EditRequestView.vue?vue&type=template&id=91af57e6&"
import script from "./EditRequestView.ts?vue&type=script&lang=ts&"
export * from "./EditRequestView.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports